import {
  Apiv2GetRequest,
  Apiv2PostRequest,
  Apiv2PutRequest,
} from '../../api-v2';
// import { _ } from 'vue-underscore';
import { showNotif } from '../notification';
import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Penjualan Depo Kredit',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/fin',
      },
      {
        text: 'Penjulan Depo Kredit',
        href: '/adm/fin/penjualan/depo-credit',
        active: true,
      },
    ],
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_inv_depo_credit',
    sortDesc: true,
    fields_account: [
      {
        key: 'code_acc',
        label: 'Kode Akun',
        sortable: true,
      },
      {
        key: 'classification',
        label: 'Klasifikasi',
        sortable: true,
      },
      {
        key: 'acc_name',
        label: 'Nama Akun',
        sortable: true,
      },
      {
        key: 'acc_alias',
        label: 'Alias',
        sortable: true,
      },
      {
        key: 'currency',
        label: 'Mata Uang',
        sortable: true,
      },
      {
        key: 'is_active',
        label: 'Aktif',
        sortable: true,
      },
    ],
    fields: [
      {
        key: 'code_inv_depo',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'date_inv',
        label: 'Tanggal',
        sortable: true,
      },
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'department',
        label: 'Dept',
        sortable: true,
      },
      {
        key: 'total_ppn10',
        label: 'PPN',
      },
      {
        key: 'total_piutang',
        label: 'Total Final',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    form: {
      id_principle: '',
      code_principle: '',
      name_principle: '',
      code_inv_depo: '',
      date_inv: '',
      date_trans: [],
      id_department: '',
      id_currency: '',
      remark: '',
      total_cost: '',
      acc_other_cost: '',
      other_cost: '',
      acc_disc_final: '',
      disc_final: '',
      total_hpp: '',
      total_ppn10: '',
      total_pph23: '',
      total_invoice: '',
      acc_payment: '',
      total_payment: '',
      id_journal: '',
      term_payment: '',
      status_inv: '',
      details: [],
    },
    journal: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  journal(state) {
    return state.data.journal;
  },
};

export const mutations = {
  changeDepoCredit(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getJournalDepoCash({ commit }, payload = null) {
    commit('changeDepoCredit', {
      loading: true,
    });

    let result = await Apiv2GetRequest(
      `fin/depo-credit/${payload.id_inv_depo_credit}/journal`
    );
    commit('changeDepoCredit', {
      loading: false,
      journal: result.error ? [] : result.data.object,
    });

    return result.error ? false : true;
  },

  async getListInvDepoCash({ commit, state }) {
    commit('changeDepoCredit', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await Apiv2GetRequest(`fin/depo-credit`, params);
    commit('changeDepoCredit', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getCostCash({ commit, state }, payload = null) {
    commit('changeDepoCredit', {
      loading: true,
    });

    const { data } = state;
    let result = await Apiv2PostRequest('fin/depo-credit/get-price', {
      date_inv: data.form.date_inv,
      ...payload,
    });

    commit('changeDepoCredit', {
      loading: false,
    });

    if (!result.error && result.data.object) {
      return result.data.object || {};
    }

    return false;
  },

  async getDetailCostCash({ commit, state }, payload = null) {
    commit('changeDepoCredit', {
      loading: true,
    });

    const { data } = state;
    let result = await Apiv2GetRequest(`fin/depo-credit/${payload.id}`);
    commit('changeDepoCredit', {
      loading: false,
    });

    if (!result.error) {
      commit('changeDepoCredit', {
        form: {
          ...data.form,
          ...result.data.object,
          date_trans: [
            result.data.object && result.data.object.date_start
              ? new Date(
                  moment(result.data.object.date_start).format('YYYY-MM-DD')
                )
              : '',
            result.data.object && result.data.object.date_end
              ? new Date(
                  moment(result.data.object.date_end).format('YYYY-MM-DD')
                )
              : '',
          ],
        },
      });

      return true;
    }

    return false;
  },

  async createCostCash({ commit, state, dispatch }) {
    commit('changeDepoCredit', {
      loading: true,
    });

    const { data } = state;
    let result = await Apiv2PostRequest('fin/depo-credit', data.form);

    commit('changeDepoCredit', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async updateCostCash({ commit, state, dispatch }, payload = null) {
    commit('changeDepoCredit', {
      loading: true,
    });

    const { data } = state;
    let result = await Apiv2PutRequest(
      `fin/depo-credit/${payload.id}`,
      data.form
    );

    commit('changeDepoCredit', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async getDetailSetupAccount({ commit }, payload = null) {
    commit('changeDepoCredit', {
      loading: true,
    });

    let result = await Apiv2GetRequest(`fin/depo-credit/${payload.id}`);
    commit('changeDepoCredit', {
      loading: false,
    });

    if (!result.error) {
      commit('changeDepoCredit', {
        detail: result.data.object,
      });
    }

    return !result.error ? true : false;
  },
};
